import { themedUseStyletron } from '../../../theme/customTheme'
import { LabelLarge } from 'baseui/typography';
import { ValueDisplayWithLabel } from '../../components/ValueDisplay'
import { OperatorPanelWrapper } from '../../components/Layout'
import { useGetMeasurmentColor } from '../../../hooks/useGetMeasurmentColor'
import { IMultisensor } from './types'
// icons
import { FaRunning } from "react-icons/fa";
import { FormattedMessage } from 'react-intl';

export const OperatorPanel = (props: IMultisensor) => {
    const [, theme] = themedUseStyletron();
    const [color] = useGetMeasurmentColor('lux');
    return (
        <OperatorPanelWrapper
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                    <FaRunning color={props.presence ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='40px' />
                    {props.presence && <LabelLarge><FormattedMessage id="Devices.PRESENCE" defaultMessage="PRESENCE" /></LabelLarge>}
                    {!props.presence && <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.NOPRESENCE" defaultMessage="NO PRESENCE" /></LabelLarge>}
                </>
            }
            operationModeContent={
                <ValueDisplayWithLabel alignSelf='flex-start' value={props.brightness} label='Brightness' dimension='lux'></ValueDisplayWithLabel>
            }
            additionalContent={
                <></>
            }>
        </OperatorPanelWrapper>
    )
} 